import { useCallback } from 'react';
import {
  isFileTypeAllowed,
  getMaxSizeForType,
  formatFileSize,
} from '../helpers/fileValidationUtils';

/**
 * Custom hook for file validation logic
 * @returns {Object} - Validation functions
 */
const useFileValidation = () => {
  const validateFile = useCallback((file) => {
    const errors = [];

    if (!isFileTypeAllowed(file)) {
      errors.push(
        'Invalid file type. Only PDF, Excel, CSV, and TXT files are allowed.'
      );
    }

    const maxSize = getMaxSizeForType(file.type);
    if (file.size > maxSize) {
      const maxSizeText = formatFileSize(maxSize);
      errors.push(`File too large. Maximum size is ${maxSizeText}.`);
    }

    return errors;
  }, []);

  const hasDuplicateFileName = useCallback((newFileName, existingFiles) => {
    return existingFiles.some(
      (existingFile) =>
        existingFile.file.path.toLowerCase() === newFileName.toLowerCase()
    );
  }, []);

  return {
    validateFile,
    hasDuplicateFileName,
  };
};

export default useFileValidation;
